// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"406abd78","246":"5533a80a","253":"aa8e2b38","525":"efef980d","608":"3ceb879e","657":"a2572ad1","907":"e7ece53d","962":"b55ef706","978":"e3612362"}[chunkId] + ".chunk.js";
};